import { Column } from '@synqo/frontend-component-library';
import { ApiCashRegister } from '@Model';

export const cashRegisterColumns: Column<ApiCashRegister>[] = [
    { name: 'label', label: 'Bezeichnung' },
    { name: 'shorthand', label: 'Suchcode' },
];
